module.exports = __webpack_public_path__ + "media/v2/components/blocks/IconGame/shared/img/survivor/td_and_yards-8c7fbdecfa8d19b05b85693d1cbed230.svg";